import React from 'react';
import { Stack } from '@mui/material';
import { IconWrapper } from 'components/Icon';
import { Avatar } from './Avatar';

export const ImageAvatar = ({ img = '', name = '', searchResult = false, anonymous = false, sx = null, width = 40, height = 40, fontSize = '1.125rem' }) => {
  if (anonymous) {
    return (
      <Stack
        alignSelf="center"
        justifyContent="center"
        alignItems="center"
        sx={{
          border: 'none !important',
          borderRadius: 1,
          bgcolor: 'grey.300',
          width: searchResult ? 25 : width,
          height: searchResult ? 25 : height,
          ...sx,
        }}
      >
        <IconWrapper
          icon="hidden"
          sx={{ svg: { width: 20, height: 20, stroke: 'white', color: 'white' } }}
        />
      </Stack>
    );
  }

  if (!img) return <Avatar name={name} searchResult={searchResult} width={width} height={height} fontSize={fontSize} initialSX={sx} />;

  return (
    <Stack
      alignSelf="center"
      justifyContent="center"
      alignItems="center"
      sx={{
        border: 'none !important',
        borderRadius: 1,
        bgcolor: 'grey.300',
        width: searchResult ? 25 : width,
        height: searchResult ? 25 : height,
        '& > img': {
          width: '100%',
          height: '100%',
          borderRadius: 0.7,
          overflow: 'hidden',
        },
        ...sx,
      }}
    >
      {img && <img src={img} />}
      {!img && (
        <IconWrapper
          icon="photo"
          sx={{ svg: { width: 20, height: 20, stroke: 'white', color: 'white' } }}
        />
      )}
    </Stack>
  );
};
